import { Controller } from '@hotwired/stimulus';

/*
 * Me he traído el inicializador de summernote que teníamos en los initializers
 */
/* global $, I18n, swal */
export default class Summernote extends Controller {
  connect() {
    const $element = $(this.element);
    const height = $element.data('height');
    const disabled = $element.data('disabled');
    // si la clave que paso es maximumImageFileSize no me devuelve el valor
    const maximumImageFileSize = $element.data('mifs');

    const summerNote = $element.summernote({
      maximumImageFileSize: (maximumImageFileSize || 1024) * 1024, // 1MB
      lang: 'es-ES',
      tabsize: 2,
      height: height || 250,
      // Necesario porque si no se queda el modal detrás de la sombra:
      // https://github.com/summernote/summernote/issues/978#issuecomment-136898378
      dialogsInBody: true,
      toolbar: [
        ['style', ['style', 'bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link', 'picture', 'hr']],
        ['height', ['height']],
      ],
      striptags: {
        stripTags: ['video', 'svg'],
      },
      callbacks: {
        onImageUploadError: (msg) => {
          swal({
            title: I18n.t('error_adjuntar_imagen_tile'),
            type: 'info',
            text: `${msg} (${maximumImageFileSize} KB) \n${I18n.t('error_adjuntar_imagen')}`,
            html: false,
          });
        },
      },
    });

    if (disabled) {
      summerNote.summernote('disable');
    }
    $element.trigger('summernote:loaded', summerNote);
  }
}
